import React, { useRef, useState } from "react";
import Select from "../../../components/form/select/Select";
import { useSelector } from "react-redux";
import { flashMessage } from "../../../utils/flash";

const SelectCover = ({ modal_id, handleChange }) => {
  const { cover } = useSelector((state) => state?.policy);

  const close = useRef();
  const coverRef = useRef();

  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);

  const handleSubmit = () => {
    setTouched(false);
    if (!selected) {
      // setTouched(true);
      setError("please select cover");
      return;
    }
    coverRef?.current?.clearValue();
    close.current?.click();
    setError("");
    handleChange(selected);
  };

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog' role='document'>
          <form
            className='modal-content rounded-4 text-dark'
            // onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Add Cover
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  coverRef?.current?.clearValue();
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='row mb-3'>
                <div className='col-md-2 text-end sm-text-end'>
                  <label htmlFor='username' className={`form-label mt-1`}>
                    Cover<span className='text-danger'>*</span>
                  </label>
                </div>
                <div className='col-md-10'>
                  <Select
                    onBlur={() => {
                      setTouched(true);
                      if (!selected) {
                        setError("please select cover");
                      }
                    }}
                    name='coverRef_type'
                    id='coverRef_type'
                    value={selected}
                    data={cover?.saving_covers?.map((item) => ({
                      label: item.cover_name,
                      value: item.id,
                    }))}
                    onChange={(value) => {
                      setSelected(value);
                      setError("");
                    }}
                    isError={error && touched}
                    ref={coverRef}
                  />
                  {error && touched && (
                    <span className='text-danger'>{error}</span>
                  )}
                </div>
              </div>
            </div>
            <div className='modal-footer me-3 mt-4'>
              <button
                type='button'
                className='btn btn-secondary btn-sm rounded-3'
                data-bs-dismiss='modal'
                onClick={() => {
                  coverRef?.current?.clearValue();
                }}
              >
                Close
              </button>
              <button
                type='button'
                className='btn btn-primary btn-sm rounded-3'
                onClick={handleSubmit}
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SelectCover;
